<template>
  <div class="record-count">
    <div class="header border-bottom">
      <p>{{ time.date }}</p>
      <div>
        <span>跟进记录数</span>
        <span>{{ recordNum }}</span>
      </div>
      <div class="customer">
        <span>跟进客户数</span>
        <span @click="$router.push({ name: 'TrackCustomer', query: { date: $route.query.date } })">{{ customerNum }}</span>
      </div>
    </div>
    <div class="record-panel border-top">
      <div class="staff-list">
        <template v-if="staffRecord.length">
          <div class="item border-bottom" v-for="item in staffRecord" :key="item.operatorId">
            <span>{{ item.operatorName }}</span>
            <span
              @click="$router.push({
                name: 'RecordDay',
                query: { date: $route.query.date, operatorId: item.operatorId, operatorName: item.operatorName }
              })"
            >
              <span>{{ item.recordNum }}</span>
              <van-icon name="arrow" />
            </span>
          </div>
        </template>
        <van-empty v-else description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { operatorTrackList, countTrackList } from '@/api/track'
export default {
  name: 'RecordCount',
  data() {
    return {
      customerNum: 0,
      recordNum: 0,
      staffRecord: []
    }
  },
  computed: {
    time() {
      const { date } = this.$route.query
      return {
        startTime: dayjs(date).startOf('day').unix(),
        endTime: dayjs(date).endOf('day').unix(),
        date: dayjs(date).format('YYYY年M月DD日')
      }
    }
  },
  created() {
    this.getTrackCount()
    this.getStaffRecord()
  },
  methods: {
    getTrackCount() { // 获取统计列表
    const { startTime, endTime } = this.time
      countTrackList({ page: 1, count: 2000, startTime, endTime }).then((res) => {
        if (res.errcode === 0) {
          const { customerNum, recordNum } = res.data.reduce((acc, item) => {
            acc.customerNum += item.customerNum
            acc.recordNum += item.recordNum
            return acc;
          }, { customerNum: 0, recordNum: 0 })
          this.customerNum = customerNum
          this.recordNum = recordNum
        }
      })
    },
    getStaffRecord() {
      // 获取员工列表追踪记录
      const { startTime, endTime } = this.time
      operatorTrackList({ page: 1, count: 2000, startTime, endTime }).then((res) => {
        if (res.errcode === 0) {
          this.staffRecord = res.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .record-count { background-color: #fff; height: 100vh;
    .header { font-size: 14px; color: #333; padding: 10px 10px 20px; line-height: 30px;
      div { display: flex; justify-content: space-between; align-items: center; }
      .customer {
        span {
          &:last-child { min-width: 50px; text-align: right; color: #0000ffc4; }
        }
      }
    }
    .record-panel { margin-top: 60px;
      .staff-list {
        .item { display: flex; justify-content: space-between; align-items: center; padding: 10px; font-size: 14px;
          span {
            &:last-child { display: flex; align-items: center;
              .van-icon-arrow { margin-left: 10px; }
            }
          }
        }
      }
    }
  }
</style>